import React from "react";
import Member from "../types/Member";

export interface AuthenticatedUserContextProps {
  member: Member | null;
  setMember: (member: Member | null) => void;
  loggedIn: boolean;
  setLoggedIn: (loggedIn: boolean) => void;
  showSignOutConfirm: boolean;
  setShowSignOutConfirm: (show: boolean) => void;
  signOut: () => Promise<void>;
  numUnreadMessages: number | null;
  setNumUnreadMessages: (num: number | null) => void;
  deviceToken: string | null;
  setDeviceToken: (deviceToken: string | null) => void;
  numUnreadFiles: number;
  setNumUnreadFiles: (num: number) => void;
  showAllCalendarEvents: boolean;
  setShowAllCalendarEvents: (show: boolean) => void;
  showAllFiles: boolean;
  setShowAllFiles: (show: boolean) => void;
}

export const AuthenticatedUserContext = React.createContext<AuthenticatedUserContextProps>({
  member: null,
  setMember: (member: Member | null) => {},
  loggedIn: false,
  setLoggedIn: (loggedIn: boolean) => {},
  showSignOutConfirm: false,
  setShowSignOutConfirm: (show: boolean) => {},
  signOut: async () => {},
  numUnreadMessages: null,
  setNumUnreadMessages: (num: number | null) => {},
  deviceToken: null,
  setDeviceToken: (deviceToken: string | null) => {},
  numUnreadFiles: 0,
  setNumUnreadFiles: (num: number) => {},
  showAllCalendarEvents: false,
  setShowAllCalendarEvents: (show: boolean) => {},
  showAllFiles: false,
  setShowAllFiles: (show: boolean) => {},
} as AuthenticatedUserContextProps);
